<template>
  <div class="gallery">
    <figure 
      class="image" 
      v-for="image in images"
      :key="image['ID']">
      <img :src="image['sizes']['large']">
      <figcaption v-if="image.caption" v-html="image.caption"></figcaption>
    </figure>
  </div>
</template>

<script>
export default {
  props: {
    gallery: Object
  },
  computed: {
    images () {
      if (this.gallery) return this.gallery.images
    }
  }
}
</script>

<style scoped lang="scss">
.gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .image {
    margin-bottom: 40px;
    img {
      max-width: 100%;
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// GalleryFull.vue?9d07c33e